
export const handleProductClickAmazon = (product) => {
  const { _id: productId, store, link } = product;

  const lastTime = localStorage.getItem('lastAffiliateVisit');
  const now = Date.now();
  const FIFTEEN_HOURS = 15 * 60 * 60 * 1000;

  // Only trigger for Amazon products
  if (store === "amazon") {
    const shouldOpenAffiliateTab = !lastTime || now - Number(lastTime) > FIFTEEN_HOURS;

    if (shouldOpenAffiliateTab) {
      const newTab = window.open(link, '_blank');

      if (newTab) {
        setTimeout(() => {
          newTab.close();
        }, 3000); // Close after 3 seconds
      }

      localStorage.setItem('lastAffiliateVisit', now.toString());
    }
  }

  // Navigate to product page
  window.location.href = `/product-page/${productId}`;
};




export const shortenNameForCartDropdown = (str, length = 15) => {
  if (str.length > length) {
    return str.substring(0, length) + '...';
  }
  return str;
};


export const capitalizeFirstLetterOfEachWord = (str) => {
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};

// original
// export const formatPrice = (price) => {
//     if (typeof price !== 'string') {
//       return price;
//     }
  
//     // Remove any non-numeric characters except the decimal point
//     const numericValue = price.replace(/[^\d.]/g, '');
  
//     // Format the number with commas as thousand separators
//     return parseFloat(numericValue).toLocaleString('en-US');
//   }



// second 
// export const formatPrice = (price) => {
//   if (price == null) return '';

//   // Convert to number if it's a string with currency or comma
//   const numeric = typeof price === 'number'
//     ? price
//     : parseFloat(price.replace(/[^\d.-]/g, ''));

//   if (isNaN(numeric)) return '';

//   return numeric.toLocaleString('en-US');
// };


// // third
// export const formatPrice = (price) => {
//   if (price == null) return '0.00';  // Return '0.00' if the price is null or undefined

//   // Convert to number if it's a string with currency or comma
//   const numeric = typeof price === 'number'
//     ? price
//     : parseFloat(price.replace(/[^\d.-]/g, ''));

//   if (isNaN(numeric)) return '0.00';  // Return '0.00' if the price can't be parsed to a valid number

//   // Format the number with commas as thousands separators
//   return numeric.toLocaleString('en-US', {
//     minimumFractionDigits: 2,  // Ensure at least two decimal places
//     maximumFractionDigits: 2,  // Limit to two decimal places
//   });
// };

// fourth 
export const formatPrice = (price) => {
  if (price == null) return '';

  // Debugging log to check what price is being passed
  console.log("Price before formatting:", price);

  // Convert to number if it's a string with currency or comma
  const numeric = typeof price === 'number'
    ? price
    : parseFloat(price.replace(/[^\d.-]/g, ''));

  // Debugging log to check the parsed numeric value
  console.log("Parsed numeric price:", numeric);

  if (isNaN(numeric)) return '';

  // Format the price with commas
  return numeric.toLocaleString('en-US');
};



  export const capitalizeFirstLetterOfEachWordAndShorten = (str, maxLength = 55) => {
    if (!str) return '';
  
    const capitalized = str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  
    if (capitalized.length > maxLength) {
      return capitalized.slice(0, maxLength).trim() + '...';
    }
  
    return capitalized;
  };

  export const shortenArabicName = (str, maxLength = 55) => {
    if (!str) return '';
  
    const trimmed = str.trim();
  
    if (trimmed.length > maxLength) {
      return trimmed.slice(0, maxLength).trim() + '...';
    }
  
    return trimmed;
  };
  
  

          // Function to generate the affiliate link in Amazon's simplified format
  export const getAmazonAffiliateLink = (link, store) => {
      // Your Amazon affiliate tracking ID
      const affiliateId = 'glamalertz0b-21'; // Replace with your actual tracking ID
      const url = new URL(link);
      
      // Only apply affiliate tag if it's an Amazon product
      if (store === 'amazon') {
          // Extract the ASIN from the Amazon URL
          const asinMatch = url.pathname.match(/\/dp\/([A-Z0-9]{10})/);
          
          if (asinMatch && asinMatch[1]) {
              const asin = asinMatch[1];
              
              // Create the simplified link
              const simplifiedLink = `https://www.amazon.sa/dp/${asin}/ref=nosim?tag=${affiliateId}`;
              
              return simplifiedLink;
          }
      }
      
      // Return the original link if not Amazon or if ASIN extraction fails
      return link;
  };

  // utils/recentlyViewed.js
export function saveToRecentlyViewed(product) {
  try {
    const key = 'recentlyViewed';
    let existing = JSON.parse(localStorage.getItem(key)) || [];

    // Remove if already exists (by _id or link)
    existing = existing.filter(item => item._id !== product._id);

    // Add to top
    existing.unshift({
      _id: product._id,
      name: product.name,
      arabicName: product.arabicName,
      image: product.image,
      prices: product.prices,
      price: product.price,
      currency: product.currency,
      store: product.store,
      link: product.link,
    });

    // Limit to 10
    if (existing.length > 10) existing.pop();

    localStorage.setItem(key, JSON.stringify(existing));
  } catch (err) {
    console.error('Failed to save to recently viewed:', err);
  }
}

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem('recentlyViewed')) || [];
  } catch {
    return [];
  }
}

  
